// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-descp {
  font-family: 'Open Sans', sans-serif;
  font-size:14px;
}

.projectdetails-title {
  font-weight: 600;
  font-family: 'Open Sans', sans-serif;
  font-size:14.5px;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Project-view/preojectview.css"],"names":[],"mappings":"AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,YAAY;AACd","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');\r\n\r\n.project-descp {\r\n  font-family: 'Open Sans', sans-serif;\r\n  font-size:14px;\r\n}\r\n\r\n.projectdetails-title {\r\n  font-weight: 600;\r\n  font-family: 'Open Sans', sans-serif;\r\n  font-size:14.5px;\r\n  color: black;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
